export default "//cloud.imgsmail.ru/cloud.mail.ru/168288/img/build/errors/error-403.png";